<template>
</template>
<script>
import FilterHeader from '@/components/JobsSearch/FilterHeader'
import SearchParams from '@/lib/enums/SearchParams'

export default {
  components: { FilterHeader },
  data() {
    return {
      SearchParams: SearchParams,
      selections: [],
      disableBtn: false
    }
  },

  props: {
    filterData: {
      type: Object,
      required: true,
      default: () => {}
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    },
    selectedOptions: {
      type: Array,
      required: false,
      default: () => []
    },
    filterDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultTitle: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    isFilterEmpty() {
      return (
        Object.keys(this.filterData).length === 0 &&
        this.filterData.constructor === Object
      )
    },
    filterTitle() {
      return !this.isFilterEmpty
        ? this.filterData.Title.Value
        : this.defaultTitle
    },
    filterOptions() {
      return !this.isFilterEmpty ? this.filterData.Options : []
    }
  },
  methods: {
    submitFilter() {
      const payload = {
        type: this.filterData.QueryParamName,
        selections: this.selections
      }
      this.$emit('submitFilter', payload)
    },
   
    // set selection to default on close filter dialog
    defaultSelections() {
      if(this.selections.toString() !== this.selectedOptions.toString()) {
        this.initSelections();
      }
    },
    cleanSelected() {
      this.selections = [];

      if (this.selectedOptions && this.selectedOptions.length > 0) {
        const payload = {
          type: this.filterData.QueryParamName,
          selections: []
        };
        this.$emit('submitFilter', payload);
      }
    },

    initSelections() {
      this.selections = this.selectedOptions;
    },
    
    // enable/disable save button on open filters or change selections
    checkSelections() {
      if(
        (this.selectedOptions.every(val => this.selections.includes(val)) && 
        this.selectedOptions.length === this.selections.length) || 
        (!this.selectedOptions.length && !this.selections.length)
      ) {
        this.disableBtn = true;
      } else {
        this.disableBtn = false;
      }
    }
  },
  mounted() {
    this.initSelections()
  },
  watch: {
    selectedOptions: function(newVal, oldVal) {
      this.initSelections()
    }
  }
}
</script>


<style lang="scss" scoped>
.search-filter {
  position: relative;
  flex: 1 1 0;
  max-width: unset;
}

.search-filter .flex,
.search-filter .child-flex > * {
  max-width: none;
}

.filter-link {
  color: black !important;
}

.category-filter-link {
  text-decoration: none;
  color: black !important;
}
</style>
